import React from "react";

import { BackToPatientProfile } from "@/components/Common/BackToPatientProfile";
import { Button2 } from "@/ui2/atoms/Button";
import { MemberHeader } from "@/features/notes/(v2)/components/MemberHeader";
import { testLocator } from "@/lib/helpers/test-locator";
import type { UUID } from "@/core/types/common";

type Props = {
  children: React.ReactNode;
  noteDraftSubmitHandler?: () => void;
  noteSubmitHandler?: () => void;
  patientId: UUID;
};

export function EditNoteWrapper({
  children,
  noteDraftSubmitHandler,
  noteSubmitHandler,
  patientId,
}: Props) {
  const hasActions = noteDraftSubmitHandler !== undefined && noteSubmitHandler !== undefined;

  return (
    <div className="tw:flex tw:flex-col tw:gap-5">
      <BackToPatientProfile patientId={patientId} />

      <MemberHeader patientId={patientId} />

      {children}

      {hasActions && (
        <div className="tw:my-3 tw:flex tw:justify-center tw:gap-4">
          <Button2
            onPress={noteDraftSubmitHandler}
            size="md"
            variant="secondary"
            {...testLocator("saveDraftBtn")}
          >
            Save Draft
          </Button2>

          <Button2 onPress={noteSubmitHandler} size="md" {...testLocator("signAndSubmitBtn")}>
            Sign & Submit
          </Button2>
        </div>
      )}
    </div>
  );
}
